import SidebarItemHard from '@/components/SidebarItemHard/SidebarItemHard';

export default SidebarItemHard;
